<template>
  <div class="form-container">

    <van-nav-bar title="入职表单"  border fixed></van-nav-bar>

    <van-form
        ref="formData"
        :model="form"
        label-width="100px"
        class="form"
        @submit="submitForm"
    >
      <van-field required
                 v-model="form.deptId"
                 label="部门"
                 input-align="left"
                 placeholder="请输入部门"
                 size="large"
                 :rules="[{ required: true, message: '请选择部门', trigger: 'blur' }]"
                 @click="showPicker = true"
                 readonly
                 clickable
                 :style="{ height: '60px', fontSize: '18px' }">
      </van-field>
      <van-field
          v-if="false"
          required
          v-model="form.name"
          label="姓名"
          input-align="left"
          placeholder="请输入姓名"
          size="large"
          :style="{ height: '60px', fontSize: '18px' }"
          :rules="[
            { required: true, message: '请输入姓名', trigger: 'blur' },
            { max: 8, message: '姓名不得超过8个字符', trigger: 'blur' }
          ]"
      ></van-field>

      <van-field
          v-if="false"
          required
          v-model="form.gender"
          label="性别"
          size="large"
          :style="{ height: '60px', fontSize: '18px' }"
          :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
      >
        <template #input>
          <van-radio-group v-model="form.gender" direction="horizontal">
            <van-radio name="0">男</van-radio>
            <van-radio name="1">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
          v-if="false"
          required
          v-model="form.idCard"
          label="身份证号码"
          :rules="[
      { required: true, message: '请输入身份证号码', trigger: 'blur' },
      { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号码', trigger: 'blur' }
    ]"
          input-align="left"
          placeholder="请输入身份证号码"
          size="large"
          :style="{ height: '60px', fontSize: '18px' }"
      ></van-field>

      <van-field
          v-if="false"
          v-model="form.birthday"
          label="生日"
          required
          input-align="left"
          type="date"
          size="large"
          placeholder="选择日期"
          :rules="[{ required: true, message: '请选择生日', trigger: 'blur' }]"
      ></van-field>

      <!--      <van-field v-model="form.workYears" label="工龄" required></van-field>-->

      <van-field
          v-if="false"
          required
          v-model="form.address"
          label="身份证地址"
          type="textarea"
          :rules="[{ required: true, message: '请输入身份证地址', trigger: 'blur' }]"
          autosize
          input-align="left"
          placeholder="请输入身份证地址"
          size="large"
      ></van-field>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
      </van-popup>

      <!--      <van-field v-model="form.insurance" label="保险" input-align="left"-->
      <!--                 placeholder="请输入银行卡开户行"-->
      <!--                 size="large"-->
      <!--                 :style="{ height: '60px', fontSize: '18px' }"></van-field>-->

      <van-field label="身份证正面" required>
        <template #input>
          <van-uploader
              v-model="idCardFrontList"
              :max-count="1"
              :after-read="afterReadIDCardFront"
              size="large"
              required
              input-align="left"
          ></van-uploader>
        </template>
      </van-field>
      <van-field label="身份证反面" required>
        <template #input>
          <van-uploader
              v-model="idCardBackList"
              :max-count="1"
              :after-read="afterReadIDCardBack"
              size="large"
              required
              input-align="left"
          ></van-uploader>
        </template>
      </van-field>
      <van-field label="个人证件照" required>
        <template #input>
          <van-uploader
              v-model="faceList"
              :max-count="1"
              :after-read="afterReadFace"
              size="large"
              required
              input-align="left"
          ></van-uploader>
        </template>
      </van-field>
      <van-field label="银行卡照片" required>
        <template #input>
          <van-uploader
              v-model="bankList"
              :max-count="1"
              :after-read="afterReadBank"
              size="large"
              required
              input-align="left"
          ></van-uploader>
        </template>
      </van-field>
      <van-field v-model="form.phone" label="电话" required
                 :rules="[
                     { required: true, message: '请输入电话', trigger: 'blur' },
                     { pattern: /^1\d{10}$/, message: '请输入正确的11位手机号码', trigger: 'blur' }
                 ]"
                 input-align="left"
                 placeholder="请输入电话"
                 size="large"
                 :style="{ height: '60px', fontSize: '18px' }"></van-field>

      <van-field v-model="form.phone1" label="家里电话" required
                 :rules="[
                     { required: true, message: '请输入家里电话', trigger: 'blur' },
                     { pattern: /^1\d{10}$/, message: '请输入正确的11位手机号码', trigger: 'blur' }
                 ]"
                 input-align="left"
                 placeholder="请输入家里电话"
                 size="large"
                 :style="{ height: '60px', fontSize: '18px' }"></van-field>

      <van-field v-model="form.accountCard" label="银行卡号" required
                 :rules="[
                    { required: true, message: '请输入银行卡号', trigger: 'blur' },
                    { pattern: /^\d{16,19}$/, message: '请输入正确的16-19位银行卡号', trigger: 'blur' }
                 ]"
                 input-align="left"
                 placeholder="请输入银行卡号"
                 size="large"
                 :style="{ height: '60px', fontSize: '18px' }"></van-field>

      <van-field v-model="form.accountAddress" required label="银行卡开户行" :rules="[{ required: true, message: '请输入银行卡开户行', trigger: 'blur' }]" input-align="left"
                 placeholder="请输入银行卡开户行"
                 size="large"
                 :style="{ height: '60px', fontSize: '18px' }"></van-field>

      <van-field
          v-model="form.remark"
          label="备注"
          type="textarea"
          autosize
          input-align="left"
          placeholder="非本人银行卡请备注银行卡持有人姓名例如（户名：张三）"
          size="large"
      ></van-field>

      <van-button round type="primary" native-type="submit" size="large">提交</van-button>

    </van-form>
  </div>
</template>

<script>
import {Toast} from "vant";
import {getAllDept} from "@/api/dept";
import {add, upload} from "@/api/staff";

export default {
  data() {
    return {
      value: '',
      showPicker: false,
      columns: [],
      columnsId: [],
      form: {
        name: '', // 姓名
        gender: '', // 性别
        idCard: '', // 身份证号码
        birthday: '', // 生日
        isSeniority: '0', // 工龄
        phone: '', // 电话
        phone1: '', // 家里电话
        // bankCardNumber: '1', // 银行卡号
        // bank: '1', // 银行卡开户行
        // notes: '1', // 备注
        address: '', // 地址
        deptId: null, // 部门
        isInsurance: '0', // 保险
        idCardFrontList: [], // 身份证正面照片列表
        idCardBackList: [], // 身份证反面照片列表
        faceList: [], // 个人证件照列表
        bankList: [], // 个人证件照列表
        accountCard: '',
        accountAddress: ''
      },
      genderOptions: [
        { value: 'male', label: '男' },
        { value: 'female', label: '女' }
      ],
      idCardBackList: [],
      idCardFrontList: [],
      faceList: [],
      bankList: [],
      message: '',
      message1: '',
      message2: '',
      message3: '',
      deptId: null
    };
  },
  methods: {
    loading() {
      getAllDept(this.deptId).then(response => {
        const list = []
        response.data.forEach(dept => {
          if (dept.children.length > 0) {
            list.push({text: dept.name, disabled: true})
            dept.children.forEach(subDept => {
              list.push(subDept.name)
              this.columnsId.push({name: subDept.name, id: subDept.id})
            })
          }
        })
        this.columns = list
      })
    },
    submitForm() {
      // 自定义加载图标
      this.loading1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 10000,
        onClose: () => {
          Toast.success({
            message: this.message,
            duration: 2000 // 固定显示 2 秒
          });
        }
      })

      const deptId = this.columnsId.find(a => a.name === this.form.deptId);

      if (deptId) {
        this.form.deptId = deptId.id;
      }

      add(this.form).then((response) => {
        if (response.code === 200) {
          this.message = '入职成功！'
          this.$router.push('/form/finish')
        } else if (response.code === 300) {
          this.message = response.message;
          this.$router.push({ path: '/form/finish', query: { message: this.message } });
        } else {
          this.message = '入职失败！'
        }
        // 关闭 loading
        this.hideLoading();
      })
    },
    hideLoading() {
      // 关闭 loading
      if (this.loading1) {
        this.loading1.clear();
        this.loading1 = null; // 清除变量
      }
    },
    afterReadIDCardFront(file) {
      // 自定义加载图标
      this.loading1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 15000,
        onClose: () => {
          Toast.success({
            message: this.message1,
            duration: 2000 // 固定显示 2 秒
          });
        }
      })
      let formData = new FormData();
      formData.append('file', file.file);

      upload(formData, '1')
          .then(response => {
            this.form.idCardFrontList = response.data.url
            this.form.address = response.data.address
            this.form.idCard = response.data.idcard
            this.form.name = response.data.name
            this.form.gender = response.data.sex === '男' ? '0' : '1'
            this.form.birthday = response.data.birthday.substring(0, 4) + '-' + response.data.birthday.substring(4, 6) + '-' + response.data.birthday.substring(6, 8)
            this.message1 = '上传成功！'
            // 关闭 loading
            this.hideLoading();
          })
          .catch(error => {
            this.form.idCardFrontList = ''
            this.message1 = '上传失败！'
            // 清除图片预览
            this.idCardFrontList = []
            this.hideLoading();
          });
    },
    afterReadIDCardBack(file) {
      // 自定义加载图标
      this.loading1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 15000,
        onClose: () => {
          Toast.success({
            message: this.message2,
            duration: 2000 // 固定显示 2 秒
          });
        }
      })

      let formData = new FormData();
      formData.append('file', file.file);

      upload(formData, '2')
          .then(response => {
            this.form.idCardBackList = response.data
            this.message2 = '上传成功！'
            // 关闭 loading
            this.hideLoading();
          })
          .catch(error => {
            this.form.idCardBackList = ''
            this.message2 = '上传失败！'
            // 清除图片预览
            this.idCardBackList = []
            this.hideLoading();
          });
    },
    afterReadFace(file) {
      // 自定义加载图标
      this.loading1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 15000,
        onClose: () => {
          Toast.success({
            message: this.message3,
            duration: 2000 // 固定显示 2 秒
          });
        }
      })

      let formData = new FormData();
      formData.append('file', file.file);

      upload(formData, '-1')
          .then(response => {
            this.form.faceList = response.data
            this.message3 = '上传成功！'
            // 关闭 loading
            this.hideLoading();
          })
          .catch(error => {
            this.form.faceList = ''
            this.message3 = '上传失败！'
            // 清除图片预览
            this.faceList = []
            this.hideLoading();
          });
    },

    afterReadBank(file) {
      // 自定义加载图标
      this.loading1 = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 15000,
        onClose: () => {
          Toast.success({
            message: this.message3,
            duration: 2000 // 固定显示 2 秒
          });
        }
      })

      let formData = new FormData();
      formData.append('file', file.file);

      upload(formData, '3')
          .then(response => {
            console.log(response.data)
            this.form.accountCard = response.data.cardNo
            this.form.accountAddress = response.data.bankInfo
            this.form.bankList = response.data.url
            this.message3 = '上传成功！'
            // 关闭 loading
            this.hideLoading();
          })
          .catch(error => {
            this.form.bankList = ''
            this.message3 = '上传失败！'
            // 清除图片预览
            this.bankList = []
            this.hideLoading();
          });
    },
    onConfirm(value) {
      this.form.deptId = value;
      this.showPicker = false;
    },
  },
  created() {
    this.deptId = this.$route.query.id ?? 27
    this.loading()
  }
};
</script>

<style>
.form-container {
  max-width: 500px;
  margin: auto;
  /* 留出顶部栏空间 */
  padding: 60px 20px 50px;
}

/* 可以根据需要调整样式 */
.van-nav-bar {
  border-bottom: 1px solid #ebedf0;
}
</style>
